<template>
    <section class="tag" id="sdkPage">
        <div class="row center-block">

            
            <div class="col-md-12" style="padding:0;">

                <div class="box">
                    
                    <!-- /.box-header -->
                    <div class="box-body">
                        
                        <iframe width="95%" height="615" :src="gitbookUrl" frameborder="0" v-if="!isDisable">
                        </iframe>
                        <div v-if="isDisable" style="width: 97.5%; display: flex; justify-content: center; height: 760px;background: rgba(51, 51, 51, 0.1);">
                            <!-- <img style="width:100%;height:100%;" src="../../../static/img/sdk/sdk_null.png" alt=""> -->
                            <div class="developer_documentation_download-copy">
                                <div>
                                    <p style="display: inline-block;">{{ $t('homePageFileDocumentationSdkNullTop') }}</p>
                                    <img style="position: relative; bottom: 20px;" src="../../../static/img/sdk/sdk_motion_null.png" alt="">
                                </div>
                                <p>{{ $t('homePageFileDocumentationSdkNullBot') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import config from '../../config'

    export default {
        name: 'TagList',
        components: {
        },
        data () {
            let token = localStorage.token ? localStorage.token : ''
            token = token.replace('Bearer ', '')
            let protocol = window.location.protocol
            let env = window.location.hostname.split('.')[0]
            let port = env === 'localhost' ? '8060' : '80'
            if (protocol === 'https:') {
                port = '443'
            }
            env = window.location.hostname
            return {
                token: token,
                sdkKebbiAirUrl: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sdk/' + 'SDK_1.0.1.11.aar?token=' + token,
                pdfKebbiAirUrl: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sdk/' + 'NUWA Robot SDK v1.1.1.pdf?token=' + token,
                sampleCodeKebbiAirUrl1: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sampleCode/' + 'CameraSdkDemo.zip?token=' + token,
                sampleCodeKebbiAirUrl2: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sampleCode/' + 'NuwaExampleLocalCommand.zip?token=' + token,
                sampleCodeKebbiAirUrl3: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sampleCode/' + 'NuwaExampleMotion.zip?token=' + token,
                sampleCodeKebbiAirUrl4: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sampleCode/' + 'NuwaExampleWakeup.zip?token=' + token,

                sdkUrl: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sdk/' + 'Mibo_SDK_release_1.0.1.0.aar?token=' + token,
                sampleCodeUrl: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sampleCode/' + 'Tutorial.zip?token=' + token,
                pdfKebbiUrl: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sdk/' + 'NUWA Robot SDK v1.0(Kebbi).pdf?token=' + token,
                pdfDannyUrl: config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sdk/' + 'NUWA Robot SDK v1.0(Danny).pdf?token=' + token,
                gitbookUrl: protocol + '//' + env + ':' + port + '/gitbook/',
                isDisable: false
            }
        },
        mounted () {
            if (sessionStorage.registeredDetail === 'true' && localStorage.token && localStorage.token !== 'null') {
                this.isDisable = false
                return
            } else {
                this.isDisable = true
            }
        },
        watch: {
            '$route.params.sdkName': function (newVal, oldVal) {
                // this.sdkUrl = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sdk/' + this.$route.params.sdkName + '.aar?token=' + this.token
                // this.sampleCodeUrl = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sampleCode/' + this.$route.params.sdkName + '.zip?token=' + this.token
                // this.pdfUrl = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiDownload + 'sdk/' + this.$route.params.sdkName + '.pdf?token=' + this.token
            }
        }
    }
</script>

<style scoped>
p{
    margin: 0px;
}
.developer_documentation_download-copy {
    /* width: 256px; */
    /* height: 66px; */
    font-family: sans-serif;
    font-size: 22px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.2px;
    color:#333333;
    /* display: flex; */
    /* flex-direction: column; */
    /* justify-content: space-around; */
    padding-top: 172px;
    /* margin-top: 172px; */
}
.disableBtn{
    pointer-events: none;
    background-color: rgba(51, 51, 51, 0.2)!important;
}
.box_p_line{
    width: 829px;
    height: 2.2px;
    opacity: 0.3;
    background: #00e0da;
    margin: 0px 10px;
    margin-bottom: 39px;
}
.btn_login_border{
    width: 201.5px;
    height: 0.1px;
    border: solid 1.2px rgba(51, 51, 51, 0.3);
    position: absolute;
    left: 10px;
    top: 48px;
}
.center-block{
    margin-top: 133px;
}
 .nuwaDevelop{
    margin: 0;
    }
.developerDocumentationSdk {
  /* width: 337px; */
  height: 59px;
  font-family: sans-serif;
  font-size: 40px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.2px;
  color: #333333;
  margin-right: 28px;
}
.developerDocumentationDer {
  /* width: 159px; */
  height: 59px;
  font-family: sans-serif;
  font-size: 40px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.2px;
  color: #333333;
}
.developerDocumentationDownload {
  width: 112px;
  height: 33px;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  color: #333333;
  margin-bottom: 24px;
}
.divDeveloperDocumentationDownload{
    margin-top:32px; 
}
.divDeveloperDocumentation{
  display: flex;
}
.rectangle_9  {
  width: 220px;
  height: 50px;
  border-radius: 10px;
  background-color: #00b5e2;
  /* background-color: var(--aqua-blue); */
  outline: none;
  border: none;
  display: inline-block;
  text-align: center;
  margin-right: 48px;
  position: relative;
}
.buttonTxt {
  width: 156px;
  height: 33px;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  text-align: center;
  color: #ffffff;
  line-height: 50px;
}
</style>
<style>
#sdkPage .box{
    box-shadow: none!important;
}
#sdkPage .center-block{
    padding-bottom: 280px;
}
</style>



// WEBPACK FOOTER //
// sdkDescription.vue?a2ba19a6